import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
  Box,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type props = {
  title: string;
  showDialog: boolean;
  closeDialog: any;
  children: any;
  buttonText?: string;
  onSubmit?: any;
  leftButtonComponent?: React.ReactNode;
  saveButtonDisabled?: boolean;
  cancelBtnRequired?: boolean;
};

export default function DialogContainer({
  title,
  showDialog,
  closeDialog,
  children,
  buttonText,
  onSubmit,
  leftButtonComponent,
  saveButtonDisabled = false,
  cancelBtnRequired = true,
}: props) {
  return (
    <Dialog
      open={showDialog}
      onClose={() => closeDialog()}
      scroll={"paper"}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      fullWidth={true}
      maxWidth={"lg"}
    >
      <DialogTitle
        className="header-txt"
        id="scroll-dialog-title"
        sx={{ fontWeight: "510" }}
      >
        {title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={closeDialog}
        sx={(theme) => ({
          position: "absolute",
          right: 12,
          top: 12,
          color: "rgba(0, 0, 0, 0.54)",
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>{children}</DialogContent>
      <DialogActions sx={{ justifyContent: "space-between" }}>
        <Box>{leftButtonComponent}</Box>
        <Box>
          {cancelBtnRequired && (
            <Button sx={{ mr: 2 }} onClick={() => closeDialog()}>
              Cancel
            </Button>
          )}
          <Button
            variant="contained"
            onClick={onSubmit}
            disabled={saveButtonDisabled}
          >
            {buttonText ? buttonText : "Save Changes"}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
